import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { skiPassAPI } from '../services/api';

const AddSkiPass = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    holderName: '',
    passType: 'day',
    resort: '',
    validFrom: '',
    validUntil: '',
    price: '',
    isActive: true
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      await skiPassAPI.createSkiPass(formData);
      setSuccess('Пас успішно створено!');
      setTimeout(() => {
        navigate('/passes');
      }, 2000);
    } catch (err) {
      setError('Не вдалося створити пас. Переконайтеся, що сервер запущено.');
      console.error('Error creating ski pass:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="skipass-page-header">
        <Link to="/" className="skipass-back-link">← Назад до тарифів</Link>
        <h1>Купити SKI Пас</h1>
        <div className="skipass-simple-nav">
          <Link to="/passes" className="skipass-nav-btn">Мої Паси</Link>
        </div>
      </div>
      
      {error && <div className="skipass-error">{error}</div>}
      {success && <div className="skipass-success">{success}</div>}
      
      <div className="skipass-pricing-section">
        <form onSubmit={handleSubmit}>
          <div className="skipass-form-group">
            <label htmlFor="holderName">Ім'я власника паса *</label>
            <input
              type="text"
              id="holderName"
              name="holderName"
              value={formData.holderName}
              onChange={handleChange}
              placeholder="Введіть ім'я"
              required
            />
          </div>

          <div className="skipass-form-group">
            <label htmlFor="passType">Тип паса *</label>
            <select
              id="passType"
              name="passType"
              value={formData.passType}
              onChange={handleChange}
              required
            >
              <option value="day">Денний пас</option>
              <option value="week">Тижневий пас</option>
              <option value="season">Сезонний пас</option>
              <option value="half-day">Пів дня</option>
            </select>
          </div>

          <div className="skipass-form-group">
            <label htmlFor="resort">Курорт *</label>
            <input
              type="text"
              id="resort"
              name="resort"
              value={formData.resort}
              onChange={handleChange}
              placeholder="наприклад, Буковель"
              required
            />
          </div>

          <div className="skipass-form-group">
            <label htmlFor="validFrom">Дійсний з *</label>
            <input
              type="date"
              id="validFrom"
              name="validFrom"
              value={formData.validFrom}
              onChange={handleChange}
              required
            />
          </div>

          <div className="skipass-form-group">
            <label htmlFor="validUntil">Дійсний до *</label>
            <input
              type="date"
              id="validUntil"
              name="validUntil"
              value={formData.validUntil}
              onChange={handleChange}
              required
            />
          </div>

          <div className="skipass-form-group">
            <label htmlFor="price">Ціна (₴) *</label>
            <input
              type="number"
              id="price"
              name="price"
              value={formData.price}
              onChange={handleChange}
              min="0"
              step="1"
              placeholder="0"
              required
            />
          </div>

          <div className="skipass-form-group">
            <label>
              <input
                type="checkbox"
                name="isActive"
                checked={formData.isActive}
                onChange={handleChange}
                style={{ marginRight: '8px' }}
              />
              Активний пас
            </label>
          </div>

          <div style={{ marginTop: '20px' }}>
            <button 
              type="submit" 
              className="skipass-btn"
              disabled={loading}
            >
              {loading ? 'Створюється...' : 'Купити пас'}
            </button>
            <button 
              type="button" 
              className="skipass-btn" 
              onClick={() => navigate('/passes')}
              style={{ marginLeft: '10px', backgroundColor: '#6c757d' }}
            >
              Скасувати
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSkiPass;
